import { render, staticRenderFns } from "./NamedTableRoundList.vue?vue&type=template&id=31d86411&scoped=true&"
import script from "./NamedTableRoundList.vue?vue&type=script&lang=js&"
export * from "./NamedTableRoundList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d86411",
  null
  
)

export default component.exports